import React from 'react';
import SliderCarousel from "./SliderCarousel";
import BarraTop from "./BarraTop";
import CardsHome from "./CardsHome";

function Pagehome(){
    return(      
           <>         
           <BarraTop />
           <SliderCarousel />
           <CardsHome />  
           </>
    )
}

export default Pagehome;